export default {
    'Debe ingresar al menos una falla a la orden.' : "Debe ingresar al menos una falla a la orden",
    'Debe ingresar el informe al cliente' : "Debe ingresar el informe al cliente"
}